import { DialogContentText, DialogContent } from '@mui/material';
import { type FC, useCallback } from 'react';

import { useMutateDeleteCodeMetaData } from '../../api/index.js';
import { type CodeMetadata } from '../../models/index.js';
import { Events, track } from '../../utils/index.js';
import DeleteDialog from '../DeleteDialog.js';

interface CodeMetadataDeleteProps {
  open: boolean;
  onClose: () => void;
  codeMetadata?: CodeMetadata;
  refetch: () => void;
}
const CodeMetadataDelete: FC<CodeMetadataDeleteProps> = ({ open, onClose, codeMetadata, refetch }) => {
  const deleteMutation = useMutateDeleteCodeMetaData();

  const onSubmit = useCallback(async () => {
    if (codeMetadata?.id){
      return deleteMutation.mutateAsync(codeMetadata.id);
    }
  }, [codeMetadata, deleteMutation]);

  const trackFn = useCallback(() => {
    track(Events.CodeMetadataDelete, {
      codeMetadatumId: codeMetadata?.id,
    });
  }, [codeMetadata]);

  return (
    <DeleteDialog
      open={open}
      name={'code-metadata'}
      onClose={onClose}
      onSubmit={onSubmit}
      refetch={refetch}
      trackFn={trackFn}
    >
      {codeMetadata ? (
        <DialogContent>
          <DialogContentText id={"code-metadata-alert-dialog-description"}>
            {codeMetadata.prompt} | {codeMetadata.inputType}
          </DialogContentText>
        </DialogContent>
      ) : null}
    </DeleteDialog>
  );
};

export default CodeMetadataDelete;
